"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.saleRegisterFactory = void 0;
const Factory = require("factory.ts");
const Mocks = require("../../../mocks");
exports.saleRegisterFactory = Factory.Sync.makeFactory({
    amount: Mocks.clare.amountTen,
    description: 'desc',
    created_at: Mocks.dates.date2000,
    line_level: 'sale_item_line',
    register_type: 'sale_item',
    price: Mocks.clare.amountTen,
    quantity: 1,
    updated_at: Mocks.dates.date2000
});
